import { Injectable } from '@angular/core';
import { Baseservice } from './baseservice';
import { AuthenticationService } from './authentication.service';

import { HttpClient } from '@angular/common/http';

@Injectable()
export class CarrierworkflowService extends Baseservice {

  constructor(http: HttpClient, authentication: AuthenticationService) {
    super('workflow', http, authentication);
  }

  startCreateCarrierWorkflow(id:number)
  {
    //console.log(`${this.url}/carrier/${id}`);

    return  this.getRequest(`${this.url}/carrier/${id}`);
  }
 
}
